
import Hero from './EntryPage';
import {useState} from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useGenericEffect } from '../components/UseGenericEffect';
import UnderConstruction from '../components/UnderConstruction';
import EventsTicker from '../components/EventsTicker';
import SEOHead from '../components/SEOHead';


export default function About() {
  const { strings } = useLanguage();
  const map = {
  };  
  const [message, setMessage] = useState('');
  return (
     <>
     <SEOHead routeId="about" slug="about" lang="ru" />
     <div className="main">
         <div className="content-wrapper">
        <section className="section">
          <div className="section-tag">
            О RPSwiss
          </div>
         </section>
           <div className="event_hero partners-hero">

            <div className="event_hero__content partners-hero__content">
              <h1 className="event_hero__title">
                О <em className="event_hero__title-accent">нас</em>
              </h1>
              <div className="event_hero__subtitle about-story">
                <p className="about-story__text">
                  RPSwiss — профессиональная ассоциация русскоязычных специалистов, предпринимателей и руководителей,
                  живущих и работающих в Швейцарии.
                </p>

                <figure className="about-photo about-photo--left">
                  <img src="/img/nt_aboutus.jpeg" alt="Надежда Тейлор" />
                  <figcaption>Надежда Тейлор</figcaption>
                </figure>

                <p className="about-story__text">
                  Мы создаём среду, в которой люди из разных профессиональных сфер могут знакомиться,
                  обмениваться знаниями и опытом, развивать свои компетенции, находить партнёров и создавать новые возможности.
                </p>

                <p className="about-story__text">
                  Ассоциация организует конференции, профессиональные и бизнес-встречи, экспертные эфиры и
                  образовательные форматы с участием специалистов из разных областей.
                </p>

                <figure className="about-photo about-photo--right">
                  <img src="/img/rl_aboutus.jpeg" alt="Рита Лаун" />
                  <figcaption>Рита Лаун</figcaption>
                </figure>

                <p className="about-story__text">
                  RPSwiss сотрудничает с образовательными организациями, компаниями, экспертами и
                  профессиональными сообществами в Швейцарии и за её пределами, создавая совместные проекты и расширяя возможности для участников ассоциации.
                </p>
              </div>
              </div>
            </div>
        </div> 
      </div>
    </>
  );
}
